import type { OrderDetailResponseDto } from "Infrastructure/Api/Api";
import { useResource } from "Infrastructure/Translation/Resources";
import {
	getOrderPaymentTabs,
	PaymentTabs,
} from "Order/Modules/Payment/Components/Tabs/hooks/useOrderPaymentTabs";
import { BlankCard } from "Shared/Components/Cards/BlankCard";
import { useStateTabs } from "Shared/Components/Tabs/Hooks/useStateTabs";
import { Tabs } from "Shared/Components/Tabs/index";
import type { FC } from "react";

type Props = {
	order: OrderDetailResponseDto;
};

export const OrderPaymentTabs: FC<Props> = ({ order }) => {
	const { t } = useResource();
	const paymentTabs = getOrderPaymentTabs(order, t);

	return (
		<BlankCard sx={{ p: 0 }}>
			<Tabs
				value={PaymentTabs.payments}
				tabs={paymentTabs}
				hookFunction={useStateTabs}
			/>
		</BlankCard>
	);
};
